import React from 'react'

const Video = ({ video }) => {
  return (
    <>
      {video.type === 'youtube' && (
        <iframe width="420" height="315" src={video.url}></iframe>
      )}
      {video.type !== 'youtube' && (
        <video>
          <source src={video.url} />
        </video>
      )}
    </>
  )
}

export default Video
